// frontend/src/components/common/Header.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import LogoutButton from "../../portal/LogoutButton";

const Header = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Lock/unlock body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMenuOpen, isMobile]);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleHomeClick = () => {
    closeMenu();
    navigate("/");
  };

  const handleArtistsClick = () => {
    closeMenu();
    navigate("/artists");
  };

  const handleAboutClick = () => {
    closeMenu();
    navigate("/about");
  };

  return (
    <>
      <header className="header">
        <div className="header-content">
          <div className="header-left">
            <img
              src="/images/fg.png"
              alt="Studio Logo"
              className="header-avatar"
              onClick={handleHomeClick}
            />

            {/* Desktop Navigation */}
            <div className="desktop-nav">
              <button
                onClick={handleHomeClick}
                className="header-nav-btn"
                type="button"
              >
                My Works
              </button>
              <button
                onClick={handleArtistsClick}
                className="header-nav-btn"
                type="button"
              >
                My Students
              </button>
              <button
                onClick={handleAboutClick}
                className="header-nav-btn"
                type="button"
              >
                About the Studio
              </button>
            </div>
          </div>

          <div className="header-right">
            {/* Desktop Logout */}
            <div className="desktop-logout">
              <LogoutButton />
            </div>

            {/* Mobile Hamburger */}
            <button
              className={`hamburger ${isMenuOpen ? "open" : ""}`}
              onClick={toggleMenu}
              type="button"
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && isMobile && (
        <div className="mobile-menu-overlay" onClick={closeMenu} />
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <nav className="mobile-nav">
          <button
            onClick={handleHomeClick}
            className="mobile-nav-btn"
            type="button"
          >
            My Works
          </button>
          <button
            onClick={handleArtistsClick}
            className="mobile-nav-btn"
            type="button"
          >
            My Students
          </button>
          <button
            onClick={handleAboutClick}
            className="mobile-nav-btn"
            type="button"
          >
            About the Studio
          </button>
          <div className="mobile-logout">
            <LogoutButton />
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
